var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33366 2.33332C4.57224 2.33332 2.33366 4.5719 2.33366 7.33332C2.33366 10.0947 4.57224 12.3333 7.33366 12.3333C10.0951 12.3333 12.3337 10.0947 12.3337 7.33332C12.3337 4.5719 10.0951 2.33332 7.33366 2.33332ZM0.666992 7.33332C0.666992 3.65142 3.65176 0.666656 7.33366 0.666656C11.0156 0.666656 14.0003 3.65142 14.0003 7.33332C14.0003 8.8739 13.4778 10.2924 12.6002 11.4213L17.0896 15.9107C17.415 16.2362 17.415 16.7638 17.0896 17.0893C16.7641 17.4147 16.2365 17.4147 15.9111 17.0892L11.4217 12.5998C10.2928 13.4774 8.87427 14 7.33366 14C3.65176 14 0.666992 11.0152 0.666992 7.33332Z",
    fill: "#B3B3B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e4f8b26c7c8a93cf053a16876463abc7.svg";
export { ForwardRef as ReactComponent };